import { useEffect } from 'react'
import { ErrorBoundary } from '@/components/error-boundary'
import { Providers } from '@/components/providers'
import { Routes } from '@/routes/routes'
import { api, apiStudent } from './lib/api-manager'
import { useAuthStore } from './store/auth-store'
import { useStudentSessionStore } from './store/student-session-store'

api.registerInterceptTokenHeader({ user: 'manager' })
apiStudent.registerInterceptTokenHeader({ user: 'student' })

function App() {
  const { clearSession: managerClearSession } = useAuthStore()
  const { clearSession: studentClearSession } = useStudentSessionStore()

  useEffect(() => {
    const removeManagerInterceptor = api.registerInterceptTokenManager(
      managerClearSession,
      { user: 'manager' }
    )

    const removeStudentInterceptor = apiStudent.registerInterceptTokenManager(
      studentClearSession,
      { user: 'student' }
    )

    return () => {
      removeManagerInterceptor()
      removeStudentInterceptor()
    }
  }, [managerClearSession, studentClearSession])

  return (
    <Providers>
      <ErrorBoundary scope="root" retryLabel="Recarregar a página">
        <Routes />
      </ErrorBoundary>
    </Providers>
  )
}

export default App
